export default __webpack_public_path__ + "static/media/our pastorate header.6f75bba5.jpg";